<template>
  <div class="">
    <!-- HELPER NAVBAR -->
    <nav class="navbar is-fixed-top has-border-bottom" role="section">
      <div class="container">
        <div class="navbar-brand">
          <!-- back button -->
          <BackButton></BackButton>
        </div>
      </div>
    </nav>


    <div
      v-if="isPageLoading"
      style="min-height: 140px; width: 100%; overflow:hidden; position: relative; margin-top: 124px"
    >
      <b-loading animation :is-full-page="false" :active.sync="isPageLoading" :can-cancel="false"></b-loading>
    </div>

    <!-- ./HELPER NAVBAR -->
    <div class="section" v-if="userPersonal && !isPageLoading">
      <div class="container">
        <h1 class="title is-size-5">{{ $t('profile.personalInfo')}}</h1>
      </div>

      <div class="mt-1">
        <!-- ROW 1 -->
        <div class="info-row">
          <div class="level is-mobile mb-half">
            <div class="level-left">
              <p class="has-text-weight-semibold">{{ $t('auth.fullName') }}</p>
            </div>
            <div class="level-right">
              <p
                class="has-text-info"
                @click="isEditLegalName = !isEditLegalName"
              >{{ isEditLegalName ? $t('ui.cancel') : $t('ui.edit') }}</p>
            </div>
          </div>
          <div>
            <div v-if="!isEditLegalName">
              <p>{{ userPersonal.legalName || 'bilgi girilmedi' }}</p>
            </div>
            <div v-else>
                <p>{{ $t('auth.enterYourRealName') }}</p>
              <b-field class="mt-1">
                <b-input :placeholder="$t('auth.fullName')" v-model="userPersonal.legalName"></b-input>
              </b-field>
              <b-field>
                <button @click="saveLegalName" disabled class="button is-primary">{{$t('ui.save') | capitalize }}</button>
              </b-field>
              <!-- <b-field :label="$t('auth.lastName')">
                <b-input v-model="userPersonal.lastName"></b-input>
              </b-field> -->
            </div>
          </div>
        </div>
        <!-- END: ROW 1 -->
        <!-- ROW 2 -->
        <!-- <div class="info-row">
          <div class="level is-mobile mb-half">
            <div class="level-left">
              <p class="has-text-weight-semibold">{{ $t('ui.legalName') }}</p>
            </div>
            <div class="level-right">
              <p class="has-text-info">{{ $t('ui.edit') }}</p>
            </div>
          </div>
          <div>
            <p>{{ userPersonal.legalName || 'not provided' }}</p>
          </div>
        </div> -->
        <!-- END: ROW 2 -->
      </div>
    </div>
  </div>
</template>

<script>
const BackButton = () =>
  import(/* webpackChunkName: "modal" */ "@/components/ui/BackButton.vue");
export default {
  components: {
    BackButton
  },
  data() {
    return {
      userPersonal: null,
      isEditLegalName: false,
      account: {},
      isPageLoading: false,
    };
  },
  created() {
    this.fetchUserPersonalInfo();
  },
  methods: {
    async fetchUserPersonalInfo() {
      // this.$store.commit("ui/SET_LOADING", true);
      this.isPageLoading = true
      try {
        const userPersonal = await this.$store.dispatch(
          "user/fetchUserPersonalInfo"
        );

        console.log("userPersonal", userPersonal);

        this.userPersonal = userPersonal;


      } catch (error) {
        if (process.env.NODE_ENV === "development") {
          console.log(error);
        }
      }
      this.isPageLoading = false
    },
    saveLegalName() {
      console.log('user to be save', this.userPersonal);
      this.isEditLegalName = false
    }
  }
};
</script>

<style lang="scss" scoper>
.info-row {
  padding-bottom: 24px;
}

.info-row + .info-row {
  padding-top: 24px;
  border-top: 1px solid $grey-lighter;
}
</style>